"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var react_cookie_1 = require("react-cookie");
var userActions_1 = require("../../user/userActions");
var LoginModal_1 = __importDefault(require("../../login/LoginModal"));
// import { setUserData } from '../../user-review/userReviewActions';
var SideControl = /** @class */ (function (_super) {
    __extends(SideControl, _super);
    function SideControl(props) {
        var _this = _super.call(this, props) || this;
        _this.showLoginModal = function () { return _this.setState({ openLoginModal: true }); };
        _this.closeLoginModal = function () {
            var resetModal = _this.props.resetModal;
            _this.setState({ openLoginModal: false });
            resetModal();
        };
        _this.reopenLogin = function () {
            var resetModal = _this.props.resetModal;
            resetModal();
        };
        var theme = window.localStorage.getItem("trybe_theme")
            ? window.localStorage.getItem("trybe_theme")
            : "light";
        _this.state = {
            lightTheme: theme === 'light' ? true : false,
            sidebarOpened: window.localStorage.getItem('loop_sidebar_state') == 'true' ? true : false,
            openLoginModal: false,
        };
        return _this;
    }
    SideControl.prototype.componentDidUpdate = function () { };
    SideControl.prototype.signOut = function () {
        var _a = this.props, cookies = _a.cookies, signOut = _a.signOut, userInfo = _a.userInfo;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "logout",
            event_category: "engagement",
            event_action: "logout",
            userId: userInfo.id,
        });
        localStorage.clear();
        cookies.remove("trybe_jwt", {
            path: "/",
            domain: ".loop.markets",
        });
        signOut();
    };
    SideControl.prototype.closeSidebar = function () {
        var sidebarOpened = this.state.sidebarOpened;
        window.localStorage.setItem("loop_sidebar_state", !sidebarOpened);
        this.setState({
            sidebarOpened: !sidebarOpened,
        });
    };
    // const SideControl = ({ url, navigator, pageName }) => {
    //   const BaseComponent = navigator ? NavLink : Link;
    //   function signOut() {
    //     // { ...state, userIsLogged: false, userInfo: {}, token: null }
    //     // setUserData({ userIsLogged: false, userInfo: {}, token: null })
    //     console.log('signout')
    //     // this.setState({
    //     //   token: null,
    //     //   userIsLogged: false,
    //     //   userInfo: {}
    //     // })
    //   }
    SideControl.prototype.render = function () {
        var _this = this;
        var userInfo = this.props.userInfo;
        var _a = this.state, sidebarOpened = _a.sidebarOpened, openLoginModal = _a.openLoginModal;
        // const { lightTheme } = this.state;
        var pageName = window.location.pathname;
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Grid, __assign({ className: sidebarOpened ? 'page-sidebar cztoggle-menu-web cz-sidebar-expanded' : 'page-sidebar cztoggle-menu-web' }, { children: (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsx)("a", __assign({ className: "navbar-brand fw-bold cz-sidebar-logo", href: "/" }, { children: (0, jsx_runtime_1.jsx)("img", { src: "/img/logo.svg", alt: "" }) })), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Grid.Row, __assign({ style: { position: 'sticky', top: '195px' } }, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.List, __assign({ link: true, inverted: true, className: "sidebar-list" }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.List.Item, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "/" }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: "/img/logo-header.png", alt: "", className: "sidebarLogo" }) })) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.List.Item, __assign({ as: "a", className: "nav-link" }, { children: (0, jsx_runtime_1.jsxs)("a", __assign({ href: "https://www.loop.markets/community/" }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: "/img/newsFeed.svg" }), (0, jsx_runtime_1.jsx)("span", __assign({ className: pageName == '/community/' ? 'cz-sidebarActive' : '' }, { children: "Community" }))] })) }))] })), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, __assign({ className: "sidebarToggle", onClick: function () { return _this.closeSidebar(); } }, { children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Image, { src: "/collapse.svg" }) }))] })), (0, jsx_runtime_1.jsx)(LoginModal_1.default, { open: openLoginModal, close: this.closeLoginModal, closePassword: this.reopenLogin })] }) })) }));
    };
    return SideControl;
}(react_1.Component));
exports.default = (0, react_cookie_1.withCookies)((0, react_router_dom_1.withRouter)((0, react_redux_1.connect)(function (state, ownProps) { return ({
    visible: state.sidebar.visible,
    mode: state.sidebar.mode,
    userInfo: state.user.userInfo,
    cookies: ownProps.cookies,
    isAdmin: state.user.userInfo.extra_capabilities,
}); }, function (dispatch) { return ({
    signOut: function () {
        dispatch((0, userActions_1.userSignOut)());
    },
    resetModal: function () {
        dispatch((0, userActions_1.returnToLoginMode)());
    }
}); })(SideControl)));
